// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mg-0";
export var leftAlign = "_mg-4";
export var listItem = "_mg-2";
export var listItemWrapper = "_mg-1";
export var operationText = "_mg-3";